import { BasePresenter } from "core/presenter";

import { OptionalSalesReportRepository } from "core/repository";

import Moment from "moment";

export default class ProductSalesReportPresenter extends BasePresenter {
  initialState() {
    const urlParams = new URLSearchParams(window.location.hash);
    const startDate = Moment(urlParams.get("inicio"), "DD-MM-YYYY");
    const endDate = Moment(urlParams.get("fim"), "DD-MM-YYYY");
    return {
      loading: true,
      filters: {
        dateFrom: startDate.isValid()
          ? startDate
          : Moment()
              .startOf("day")
              .subtract(7, "days"),
        dateTo: endDate.isValid() ? endDate : Moment().endOf("day")
      },
      pagination: {
        page: 1,
        perPage: 25,
        total: 0
      },
      summary: {
        revenues: 0,
        costs: 0,
        profit: 0
      },
      results: [],
      product: {
        name: "",
        uuid: null
      },
      user: {
        name: "",
        uuid: null
      },
      mode: "product"
    };
  }

  async onStart() {
    this.load();
  }

  async load() {
    this.viewModel.loading = true;
    this.viewModel.results = [];
    let resultsPromise;
    this.viewModel.mode = "product";
    resultsPromise = this.loadProductResults();

    await Promise.all([
      resultsPromise,
      this.loadSummary(this.viewModel.product)
    ]);

    this.viewModel.loading = false;
  }

  async loadProductResults() {
    this.renewCancelToken();
    const { filters } = this.viewModel;
    const { dateFrom, dateTo } = filters;
    const startDate = Moment(dateFrom).toISOString();
    const endDate = Moment(dateTo)
      .endOf("day")
      .toISOString();

    const res = await OptionalSalesReportRepository.getOptionalReport(
      startDate,
      endDate
    );

    const result = res.data;
    if (res.success) {
      const lengthResult = result.length;
      this.viewModel.result = result;
      this.viewModel.pagination = {
        ...this.viewModel.pagination,
        total: lengthResult,
        perPage: 25
      };
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          "Não foi possível carregar os opcionais.\nTente novamente mais tarde ou entre em contato com o suporte."
      });
    }
  }

  async loadSummary() {}

  onPageChange(page) {
    //pra arrumar a paginação em breve
    this.viewModel.pagination.page = page;
    this.load();
  }

  onFilterChange(filters) {
    if (filters.dateFrom && filters.dateTo) {
      window.location.hash = `?&inicio=${Moment(filters.dateFrom).format(
        "DD-MM-YYYY"
      )}&fim=${Moment(filters.dateTo).format("DD-MM-YYYY")}`;
    }
    for (const key in filters) {
      if (filters[key] !== this.viewModel.filters[key]) {
        this.viewModel.filters = {
          ...this.viewModel.filters,
          ...filters
        };
        this.viewModel.pagination.page = 1;
        this.load();
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/app/management/opcionais-sales-report/presenter.js